import { createRouter, createWebHistory } from 'vue-router';
import _isEmpty from 'lodash.isempty';
import store from '@/store';

const routes = [
  {
    // path: "*",
    path: '/:catchAll(.*)',
    name: 'NotFound',
    redirect: '/documents',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/documents',
    name: 'Home',
    component: () => import(/* webpackChunkName: "platform" */ '../views/Platform.vue'),
    meta: { requiresAuthentication: true },
    children: [
      {
        path: '/documents',
        name: 'PlatformDocuments',
        component: () => import(/* webpackChunkName: "platform-documents" */ '../views/PlatformDocuments.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const pathThatRequiresAuth = to.matched.some((record) => record.meta.requiresAuthentication);
  if (pathThatRequiresAuth) {
    (async () => {
      await store.dispatch('authorization/checkIfUserSessionExists');
      const isAuthenticated = store.getters['authorization/userSession'];
      if (!_isEmpty(isAuthenticated)) {
        next();
      } else {
        next({ name: 'Login' });
      }
    })();
  } else {
    next();
  }
});

export default router;
